const BaseModule = require('../../90_utils/base/BaseModule');

class VerticalGraph extends BaseModule {

	constructor(el, params) {

		super(el);

		this.graphTemplate = _.template(this.$el.find('#graph-template').html());
		this.$el.find('#graph-template').remove();

		this.domData;

		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		if(this.isFirstBuild){
			this._retrieveDomData();
			this._rebuild();
		}
	}

	_addListeners(){

	}

	_removeListeners(){

	}

	//

	_show(){

		let $lines = this.$el.find('.lines li');
		let $bars = this.$el.find('.bar svg rect');
		let $values = this.$el.find('.bar svg text');
		let $labels = this.$el.find('.label');
		let $linewrappers = this.$el.find('.line-wrapper svg');

		TweenMax.set($linewrappers, { overflow: 'hidden' });
		TweenMax.set([$lines, $labels, $values], { opacity: 0 });
		TweenMax.set($bars, { y: '100%' });

		TweenMax.staggerTo($lines, 0.3, {
			opacity: 1,
			clearProps: 'opacity',
			ease: 'fade'
		}, -0.008);

		TweenMax.staggerTo($bars, 0.8, {
			y: '0%',
			ease: 'progressSlide',
			clearProps: 'y',
			onComplete: ()=>{

				TweenMax.set($linewrappers, { clearProps: 'overflow' });

				TweenMax.staggerTo($values, 0.3, {
					opacity: 1,
					ease: 'fade'
				}, 0.1);
			}
		}, 0.15);

		TweenMax.staggerTo($labels, 0.3, {
			opacity: 1,
			ease: 'fade',
			delay: 0.2
		}, 0.1);
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	// public swap data / rebuild method

	swapData(graphData){
		this.graphData = graphData;
		this._rebuild();
	}

	//

	_retrieveDomData(){

		let $domData = this.$el.find('.dom-data');

		this.domData = {
			minValue: 0,
			maxValue: $domData.data('max-value'),
			increment: $domData.data('increment'),
			incrementCount: $domData.data('increment-count'),
			dataPoints: [],
			lineLabels: []
		}

		let $gradient = $domData.find('>.gradient');

		if($gradient.length){
			this.domData.gradient = {
				start: $gradient.attr('data-start'),
				stop: $gradient.attr('data-stop')
			}
		}

		let $dataPoints = $domData.find('>.data-point');

		$dataPoints.each((index, value) => {

			let $dataPoint = $(value);

			this.domData.dataPoints.push({
				label: $dataPoint.data('label'),
				bar: null,
				greyBar: null
			});

			let dataPoint = this.domData.dataPoints[index];
			let $bar = $dataPoint.find('.bar--primary');
			let $greyBar = $dataPoint.find('.bar--grey');

			dataPoint.bar = {
				value: $bar.data('value'),
				unit: $bar.data('unit'),
				valueLabel: $bar.data('value-label')
			};

			if($greyBar.length){
				dataPoint.greyBar = {
					value: $greyBar.data('value'),
					unit: $greyBar.data('unit'),
					valueLabel: $bar.data('value-label')
				};
			}
		});

		for(let i=0; i<this.domData.incrementCount; i++){
			if(i%5 === 0){
				this.domData.lineLabels.push({
					label: window.utils.NumberUtils.formatNumber(this.domData.maxValue - i * this.domData.increment, 2),
					textY: 0
				});
			}
		}

		this.domData.minValue = this.domData.maxValue - this.domData.incrementCount * this.domData.increment;

		this.domData.lineLabels.push({
			label: window.utils.NumberUtils.formatNumber(this.domData.minValue, 2),
			textY: 0
		});
	}

	_rebuild(){

		let $bgLines = this.$el.find('.lines');
		this.domData.graphHeight = $bgLines.outerHeight();
		this.domData.maxLineHeight = this.domData.graphHeight + 10;

		// line labels

		let numBreaks = this.domData.lineLabels.length;

		for(let i=1; i<numBreaks-1; i++){
			this.domData.lineLabels[i].textY = this.domData.graphHeight / (numBreaks - 1) * i; // -1 removes extra at end
		}

		this.domData.lineLabels[numBreaks-1].textY = this.domData.graphHeight;

		// graph content

		let barValueRange = this.domData.maxValue - this.domData.minValue;
		let barValueOffset = this.domData.maxValue - barValueRange;

		for(let i=0; i<this.domData.dataPoints.length; i++){

			let dataPoint = this.domData.dataPoints[i];

			if(dataPoint.bar){

				let barData = dataPoint.bar;
				let valueLabel = window.utils.NumberUtils.addCommas(barData.value);
				let lineHeight = parseFloat($bgLines.outerHeight()) * ((barData.value - barValueOffset)/(this.domData.maxValue - barValueOffset)) + 10;
				let lineY = this.domData.graphHeight - (lineHeight - 10);
				let textY = lineY - 15;

				if(barData.unit === '$'){ valueLabel = barData.unit + valueLabel; }
				else { valueLabel = valueLabel + barData.unit; }

				barData.view = {
					svgId: ++window.SETTINGS.vars.svgIndex,
					lineHeight: lineHeight,
					lineY: lineY,
					textY: textY,
					valueLabel: barData.valueLabel ? barData.valueLabel : valueLabel
				};
			}

			if(dataPoint.greyBar){

				let barData = dataPoint.greyBar;
				let valueLabel = window.utils.NumberUtils.addCommas(barData.value);
				let lineHeight = parseFloat($bgLines.outerHeight()) * ((barData.value - barValueOffset)/(this.domData.maxValue - barValueOffset)) + 10;
				let lineY = this.domData.graphHeight - (lineHeight - 10);
				let textY = lineY - 15;

				if(barData.unit === '$'){ valueLabel = barData.unit + valueLabel; }
				else { valueLabel = valueLabel + barData.unit; }

				barData.view = {
					lineHeight: lineHeight,
					lineY: lineY,
					textY: textY,
					valueLabel: barData.valueLabel ? barData.valueLabel : valueLabel
				};
			}
		}

		this.$el.find('.template-wrapper').html(this.graphTemplate(this.domData));

		this.isFirstBuild = false;
	}

	//

	_domUpdate(){

	}

	_resize(){
		if(this.domData){
			this._rebuild();
		}
	}

}

module.exports = VerticalGraph;
